<template>
  <div class="card">
    <slot>
      <div>Default Card Content</div>
    </slot>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "Card"
});
</script>

<style lang="postcss" scoped>
.card {
  @apply mx-1 rounded-lg shadow overflow-hidden;;
}
</style>